(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/test-panel.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/test-panel.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const logger = svs.playerLoginReact.logger;
const _svs$ui = svs.ui,
  Button = _svs$ui.ReactButton,
  Icon = _svs$ui.ReactIcon;
const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardBody = _svs$ui$ReactCard.CardBody;

const TestPanel = () => {
  const _ReactRedux$useSelect = ReactRedux.useSelector(state => state.playerloginreact),
    bankIdSsn = _ReactRedux$useSelect.bankIdSsn,
    autoStartToken = _ReactRedux$useSelect.autoStartToken,
    returnUrl = _ReactRedux$useSelect.returnUrl,
    isTestEnvironment = _ReactRedux$useSelect.isTestEnvironment;
  const _React$useState = React.useState(Boolean(svs.utils.url.queryString['hide-test'])),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    isHide = _React$useState2[0];

  const showMissingSsnDialog = message => {
    const missingSsnDialog = new svs.ui.dialog.Confirm({
      icon: 'info',
      branding: svs.ui.dialog.branding.TUR,
      title: message,
      actions: [{
        title: 'Okej'
      }]
    });
    svs.ui.dialog.api.add(missingSsnDialog);
  };

  const acceptBankIdSim = (ast, ssn) => {
    try {
      (() => {
        new Image().src = "https://bankid-sim.internt.svenskaspel.se/test/requests/update?autostartToken=".concat(ast, "&personalNumber=").concat(ssn, "&action=accept");
      })();
    } catch (e) {
      logger.debug('Error when accepting login in BankId-sim', e);
    }
  };

  const getSsnFromLocalStorage = async () => new Promise(resolve => {
    svs.components.Storage.browser.get('ssn', 'svs.testlogin.bankidsim', data => {
      resolve(data);
    });
  });

  const acceptBankIdSimLoginSsn = async e => {
    var _e$currentTarget, _e$currentTarget2;
    const ast = e === null || e === void 0 || (_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 || (_e$currentTarget = _e$currentTarget.dataset) === null || _e$currentTarget === void 0 ? void 0 : _e$currentTarget.autostarttoken;
    const ssnFromDataset = e === null || e === void 0 || (_e$currentTarget2 = e.currentTarget) === null || _e$currentTarget2 === void 0 || (_e$currentTarget2 = _e$currentTarget2.dataset) === null || _e$currentTarget2 === void 0 ? void 0 : _e$currentTarget2.ssn;
    const ssnFromLocalStorage = await getSsnFromLocalStorage();

    const ssn = prompt('Ange personnummer en kund du vill logga in med (12 siffror):', ssnFromDataset || ssnFromLocalStorage);
    if (ssn) {
      svs.components.Storage.browser.set('ssn', 'svs.testlogin.bankidsim', ssn, svs.components.Storage.constants.EXPIRES_1YEAR);
      acceptBankIdSim(ast, ssn);
    } else {
      showMissingSsnDialog('Du måste ange ett personnummer på en testkund.');
    }
  };

  const acceptBankIdSimLogin = async e => {
    const dialog = svs.ui.dialog;
    const ast = e.currentTarget.dataset.autostarttoken;
    const retUrl = e.currentTarget.dataset.returnurl;
    const users = svs.components.Storage.browser.get('savedusers', 'svs.testlogin') || [];
    const dialogMessage = [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Välj EN kund från Snabbinloggningen.'
    }, {
      type: svs.ui.dialog.message.TEXT,
      text: 'Det ÖVERSTA personnumret som väljs kommer att användas.'
    }, {
      type: svs.ui.dialog.message.TEXT,
      text: "Till <a href=\"/snabb-inloggning?returnUrl=".concat(retUrl, "\">Snabbinloggningen</a> f\xF6r att hantera testkunder och/eller logga in den v\xE4gen.")
    }];
    let ssn = e.currentTarget.dataset.ssn;
    if (!ssn) {
      users.forEach(user => {
        dialogMessage.push({
          type: svs.ui.dialog.message.CHECKBOX,
          block: true,
          align: svs.ui.dialog.message.align.LEFT,
          text: "".concat(user.ssn, " ").concat(user.firstName, " ").concat(user.lastName),
          value: user.ssn
        });
      });
      const showSelectUserDialog = () => new Promise(resolve => {
        const ssnDialog = new dialog.Confirm({
          title: 'Välj kund',
          branding: svs.ui.dialog.branding.TUR,
          icon: 'login',
          area: svs.ui.dialog.area.POPUP,
          message: dialogMessage,
          actions: [{
            title: 'Avbryt',
            callback() {
              ssnDialog.close();
              resolve();
            }
          }, {
            title: 'Logga in',
            showLoader: true,
            callback(e, forms) {
              const arrayForms = Array.from(forms);
              const selectedUser = arrayForms.find(element => element.checked);
              if (selectedUser) {
                ssn = selectedUser.value;
              }
              ssnDialog.close();
              resolve();
            }
          }]
        });
        svs.ui.dialog.api.add(ssnDialog);
      });
      await showSelectUserDialog();
    }
    if (ssn) {
      acceptBankIdSim(ast, ssn);
    } else {
      showMissingSsnDialog('Du måste välja en testkund.');
    }
  };

  const navigateToQuickLogin = () => {
    const returnUrlQs = returnUrl ? "?returnUrl=".concat(encodeURIComponent(returnUrl)) : '';
    svs.utils.url.navigate(svs.utils.url.makeInternal("".concat(svs.core.urlMapping.get('quickLogin')).concat(returnUrlQs), svs.core.urlMapping.get('startPage')));
  };

  const hideTestPanel = () => {
    $('.test-panel').hide();
  };

  const showTestPanelInfo = e => {
    const dialog = svs.ui.dialog;
    const panelInfoDialog = new dialog.Contextual({
      area: svs.ui.dialog.area.CONTEXTUAL,
      branding: svs.ui.dialog.branding.TUR,
      attachTo: e.currentTarget,
      title: '',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: 'Med testpanelen kan du:'
      }, {
        type: svs.ui.dialog.message.TEXT,
        text: '- Logga in via Snabbinloggningen genom att använda knappen "LOGGA IN VIA SNABBINLOGGNING". ' + 'Den tar dig till Snabbinloggningen med aktuell destination som returnUrl. Du behöver inte påbörja inloggningen.'
      }, {
        type: svs.ui.dialog.message.TEXT,
        text: '- Acceptera inloggningen via BankID-simulatorn direkt här från logga in-sidan genom att använda knappen "ACCEPTERA MED BANKID-SIM", ' + 'som blir synlig när du har påbörjat en inloggning.'
      }, {
        type: svs.ui.dialog.message.TEXT,
        text: 'Även autoStartToken blir synlig när du påbörjar en inloggning ifall om du vill använda BankID-simulatorn för att hantera inloggningen.'
      }]
    });
    svs.ui.dialog.api.add(panelInfoDialog);
  };
  return isTestEnvironment && !isHide && React.createElement("div", {
    className: "test-panel"
  }, React.createElement(Card, {
    branding: "tur"
  }, React.createElement(CardBody, {
    className: "f-body fc-navy"
  }, React.createElement("div", {
    className: "f-550 margin-xs-h-0 inline-block"
  }, "Test-panel", ' ', React.createElement("span", {
    className: "show-test-panel-info",
    onClick: showTestPanelInfo
  }, React.createElement(Icon, {
    icon: "information",
    size: "200"
  }))), React.createElement("div", {
    className: "test-panel-hide f-200 f-medium margin-xs-h-0 inline-block right",
    onClick: hideTestPanel
  }, "[D\xF6lj]"), React.createElement("div", {
    className: "margin-xs-top quick-login-button"
  }, React.createElement(Button, {
    block: true,
    inverted: false,
    onClick: navigateToQuickLogin,
    size: 100,
    transparent: true
  }, "Logga in via snabbinloggning:", ' ', returnUrl)), autoStartToken && React.createElement("div", {
    className: "margin-xs-top autostarttoken-info f-400"
  }, "AUTOSTARTTOKEN:", React.createElement("p", {
    className: "autostarttoken-info-text"
  }, autoStartToken), React.createElement(Button, {
    block: true,
    className: "margin-xs-top",
    "data-autostarttoken": autoStartToken,
    "data-returnurl": returnUrl,
    "data-ssn": bankIdSsn,
    inverted: false,
    onClick: acceptBankIdSimLogin,
    size: 100,
    transparent: true
  }, "Acceptera BankID-sim med snabbinloggningskund"), React.createElement(Button, {
    block: true,
    className: "margin-xs-top",
    "data-autostarttoken": autoStartToken,
    "data-returnurl": returnUrl,
    "data-ssn": bankIdSsn,
    inverted: false,
    onClick: acceptBankIdSimLoginSsn,
    size: 100,
    transparent: true
  }, "Acceptera BankID-sim ange personnummer")))));
};
svs.playerLoginReact.sharedComponents.TestPanel = TestPanel;

 })(window);